import { upperFirst } from "lodash";
import { type MediaDataRoomVersion } from "features/mediaDataRoom/models";

const interestAggregationKey = "interest";

export const getAggregationPresentation = (aggregationName: string): string =>
  aggregationName === interestAggregationKey
    ? "Segment"
    : upperFirst(aggregationName);

export interface AggregationData {
  addressableAudienceSize: number;
  affinityRatio: number;
  age?: string;
  aggregationName?: string;
  interest?: string;
  gender?: string;
  shareInMatchableAudience: number;
  shareInOverlap: number;
}

export enum OverlapInsightsVisualizeDirection {
  top = "top",
  bottom = "bottom",
}

export type OverlapInsightsChartTypes = "RADAR" | "LINE" | "TAG_CLOUD";

export enum OverlapInsightsExecutionContext {
  insightsTab = "insights_tab",
  advertiserInsights = "advertiser_insights",
  publisherInsights = "publisher_insights",
}

export type MediaDataRoomInsightsFormVisualizeValue = {
  limit: number | undefined;
  orderBy: string;
  direction: OverlapInsightsVisualizeDirection;
};

export type OverlapInsightsAggregationHookResult = {
  aggregationData: AggregationData[];
  isEmptyAggregation: boolean;
  suppressedValues: string[];
  possibleValues: string[];
  hasSuppressedValues: boolean;
  hiddenValues: (string | undefined)[];
  hasHiddenValues: boolean;
  version: MediaDataRoomVersion;
};

export const INSIGHTS_CHART_VALUE_KEY_BUTTONS: {
  label: string;
  value: string;
}[] = [
  {
    label: "Overlap",
    value: "shareInOverlap",
  },
  {
    label: "Baseline",
    value: "shareInMatchableAudience",
  },
];

export interface MediaDataRoomInsightsFormValues {
  aggregation: string;
  audienceType: string;
  chartType: OverlapInsightsChartTypes;
  visualize: MediaDataRoomInsightsFormVisualizeValue;
}
